import React from 'react';
import ReactDOM from 'react-dom';
import { useSelector } from 'react-redux';
import { isBrowser } from 'ws-scripts/modules/environment';
import { useRequestData, usePrefs, useFlags } from 'wsm-common-data';
import VehicleTitle from '../components/VehicleTitle';
import useVehicleViews from '../hooks/useVehicleViews';
import { isExistAttrConfig } from '../utils/utility';
import { highlightedAttrs, SIDEBAR_CLASS } from '../global-constants';

const Widget = () => {
	const { deviceType } = useRequestData();
	const prefs = usePrefs();
	const flags = useFlags();
	const useHighlightedAttrIDC =
		flags['vdp-use-highlighted-attributes-from-idc'];

	const { vehicle, highlightedAttrsConfig } = useSelector((state) => state);

	const shouldRequestVehicleViews =
		(prefs.enableVehicleViews === 'true' && !useHighlightedAttrIDC) ||
		isExistAttrConfig(
			highlightedAttrsConfig,
			highlightedAttrs.VEHICLE_VIEWS,
			useHighlightedAttrIDC
		);
	const { viewsError, viewsData } = useVehicleViews(
		vehicle.vin,
		prefs.vehicleViews_timeFrame,
		shouldRequestVehicleViews
	);

	if (vehicle) {
		let portal;
		const isDesktop = deviceType === 'DESKTOP';
		// Put VehicleTitle component in the sidebar of some VDPs on desktop
		if (isBrowser && isDesktop) {
			const [container] = document.querySelectorAll(`.${SIDEBAR_CLASS}`);
			if (container) {
				portal = ReactDOM.createPortal(
					<VehicleTitle
						isInSidebar
						vehicleViews={viewsData}
						viewsError={viewsError}
					/>,
					container
				);
			}
		}
		return (
			<>
				<VehicleTitle
					vehicleViews={viewsData}
					viewsError={viewsError}
				/>
				{portal}
			</>
		);
	}
	return null;
};

export default Widget;
